import { render, staticRenderFns } from "./GroupMultiSelect.vue?vue&type=template&id=36024abd"
import script from "./GroupMultiSelect.vue?vue&type=script&lang=js"
export * from "./GroupMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports